import em1_arrears from "./arrears/arrears-email-day-1";
import em2_arrears from "./arrears/arrears-email-day-2";
import em4_arrears from "./arrears/arrears-email-day-4";
import em5_arrears from "./arrears/arrears-email-day-5";
import em6_arrears from "./arrears/arrears-email-day-6";
import em7_arreras from "./arrears/arrears-email-day-7";
import em8_arrears from "./arrears/arrears-email-day-8";
import em9_arrears from "./arrears/arrears-email-day-9";
import em11_arrears from "./arrears/arrears-email-day-11";

import em1_addacs from "./addacs/addacs-email-day-1";
import em2_addacs from "./addacs/addacs-email-day-2";
import em3_addacs from "./addacs/addacs-email-day-3";
import em4_addacs from "./addacs/addacs-email-day-4";
import em5_addacs from "./addacs/addacs-email-day-5";
import em7_addacs from "./addacs/addacs-email-day-7";

interface IchaseTimeLineData {
  day: number;
  type: "arrears" | "addacs" | any;
  default_date: string;
  vehicle_reg: string;
  payment_link: string;
  phone_number: string;
  cancellation_date: string;
  next_attempt_date: string;
  outcome_date: string;
  total_due: string;
}

const chaseTimeLineData = ({
  day,
  type,
  default_date,
  vehicle_reg,
  payment_link,
  phone_number,
  cancellation_date,
  next_attempt_date,
  outcome_date,
  total_due,
}: IchaseTimeLineData) => {
  const contentData = [
    {
      day: 1,
      emails: [
        {
          type: "arrears",
          subject: `${vehicle_reg} - Missed Payment - Action Needed to Keep Your Insurance Active`,
          template: em1_arrears,
        },
        {
          type: "addacs",
          subject: `${vehicle_reg} - Direct Debit Cancelled - Action Needed Within 7 Days`,
          template: em1_addacs,
        },
      ],
      sms: [
        {
          type: "arrears",
          message: `Insurance payment missed ${default_date} for ${vehicle_reg}. Review and pay today to prevent cancellation: ${payment_link} or call ${phone_number}`,
        },
        {
          type: "addacs",
          message: `Direct Debit for ${vehicle_reg} cancelled. Call ${phone_number} to reinstate your loan. Please ensure this is done within 7 days to avoid cancellation.`,
        },
      ],
    },
    {
      day: 2,
      emails: [
        {
          type: "arrears",
          subject: `${vehicle_reg} - Urgent Reminder: Insurance Payment Still Unpaid`,
          template: em2_arrears,
        },
        {
          type: "addacs",
          subject: `${vehicle_reg} - Urgent: Payment Still Due - 6 Days Left`,
          template: em2_addacs,
        },
      ],
      sms: [
        {
          type: "arrears",
          message: `Reminder: Insurance payment for ${vehicle_reg} due ${default_date} is still unpaid. Pay today to prevent cancellation: ${payment_link} or call ${phone_number}`,
        },
        {
          type: "addacs",
          message: `Reminder: You've cancelled your direct debit for ${vehicle_reg}. Call ${phone_number} to reinstate before ${cancellation_date}.`,
        },
      ],
    },
    {
      day: 3,
      emails: [
        {
          type: "arrears",
          subject: `${vehicle_reg} - Direct Debit Reattempt Scheduled for ${next_attempt_date}`,
          template: em4_arrears,
        },
        {
          type: "addacs",
          subject: `${vehicle_reg} - Payment Still Outstanding - 5 Days Left`,
          template: em3_addacs,
        },
      ],
      sms: [
        {
          type: "arrears",
          message: `We will re-attempt to collect your Direct Debit for ${vehicle_reg} on ${next_attempt_date}. Ensure funds are available. No other action needed.`,
        },
        {
          type: "addacs",
          message: `${vehicle_reg} at risk: you've cancelled your direct debit. Call ${phone_number} to reinstate before ${cancellation_date}.`,
        },
      ],
    },
    {
      day: 4,
      emails: [
        {
          type: "arrears",
          subject: `${vehicle_reg} - Direct Debit Reattempt Scheduled for ${next_attempt_date}`,
          template: em4_arrears,
        },
        {
          type: "addacs",
          subject: `${vehicle_reg} - 4 Days Left to Prevent Policy Cancellation`,
          template: em4_addacs,
        },
      ],
      sms: [
        {
          type: "arrears",
          message: `We will re-attempt to collect your Direct Debit for ${vehicle_reg} on ${next_attempt_date}. Ensure funds are available. No other action needed.`,
        },
        {
          type: "addacs",
          message: `4 days left: you've cancelled your direct debit. Call ${phone_number} to reinstate or ${vehicle_reg} may cancel on ${cancellation_date}.`,
        },
      ],
    },
    {
      day: 5,
      emails: [
        {
          type: "arrears",
          subject: ` ${vehicle_reg} - Direct Debit Collection Today - Cancellation Risk if Unsuccessful`,
          template: em5_arrears,
        },
      ],
      sms: [
        {
          type: "arrears",
          message: `Your Direct Debit for ${vehicle_reg} is being collected today. Ensure funds are available. Failed payment may result in cancellation.`,
        },
      ],
    },
    {
      day: 6,
      emails: [
        {
          type: "arrears-approved",
          subject: `${vehicle_reg} - Payment Successful - Thank You`,
          template: em6_arrears,
        },
        {
          type: "arrears-rejected",
          subject: `${vehicle_reg} - Payment Failed - Insurance Cancellation Imminent`,
          template: em7_arreras,
        },
        {
          type: "addacs",
          subject: `${vehicle_reg} - 2 Days Left - Cancellation Imminent`,
          template: em5_addacs,
        },
      ],
      sms: [
        {
          type: "arrears-approved",
          message: `Good news: your payment for ${vehicle_reg} on ${outcome_date} was collected successfully. Your account is now up to date and your policy continues as normal. Thank you for being a valued customer.`,
        },
        {
          type: "arrears-rejected",
          message: `Payment for ${vehicle_reg} has failed. £${total_due} overdue. Make payment today to prevent cancellation and credit impact: ${payment_link} or call ${phone_number}`,
        },
        {
          type: "addacs",
          message: `Urgent: ${vehicle_reg} cancels in 2 days. You've cancelled your direct debit. Call ${phone_number} now to keep cover active.`,
        },
      ],
    },
    {
      day: 7,
      emails: [
        {
          type: "addacs",
          subject: `${vehicle_reg} - Notice of Cancellation - Policy Cancelling Today`,
          template: em7_addacs,
        },
      ],
      sms: [
        {
          type: "addacs",
          message: `NOTICE: Your policy for ${vehicle_reg} is set to cancel today as you've cancelled your direct debit. Call ${phone_number} urgently if you still need cover.`,
        },
      ],
    },

    {
      day: 8,
      emails: [
        {
          type: "arrears",
          subject: `${vehicle_reg} - Immediate Payment Required to Avoid Cancellation`,
          template: em8_arrears,
        },
      ],
      sms: [
        {
          type: "arrears",
          message: `Reminder: ${vehicle_reg} payment of £${total_due} is still unpaid. Pay today to prevent cancellation and credit issues: ${payment_link} or call ${phone_number}`,
        },
      ],
    },

    // ----------------------- JUST FOR ARREARS ------------------------------------
    {
      day: 10,
      emails: [
        {
          type: "arrears",
          subject: `${vehicle_reg} - Insurance Will Be Cancelled on ${cancellation_date} Unless Paid`,
          template: em9_arrears,
        },
      ],
      sms: [
        {
          type: "arrears",
          message: `Urgent: ${vehicle_reg} payment of £${total_due} still unpaid. Policy will cancel on ${cancellation_date} unless paid: ${payment_link} or call ${phone_number}`,
        },
      ],
    },
    {
      day: 11,
      emails: [
        {
          type: "arrears",
          subject: `${vehicle_reg} - Immediate Payment Required to Avoid Cancellation`,
          template: em8_arrears,
        },
      ],
      sms: [
        {
          type: "arrears",
          message: `Reminder: ${vehicle_reg} payment of £${total_due} is still unpaid. Pay today to prevent cancellation and credit issues: ${payment_link} or call ${phone_number}`,
        },
      ],
    },
    {
      day: 12,
      emails: [
        {
          type: "arrears",
          subject: `${vehicle_reg} - Insurance Will Be Cancelled on ${cancellation_date} Unless Paid`,
          template: em9_arrears,
        },
      ],
      sms: [
        {
          type: "arrears",
          message: `Urgent: ${vehicle_reg} payment of £${total_due} still unpaid. Policy will cancel on ${cancellation_date} unless paid: ${payment_link} or call ${phone_number}`,
        },
      ],
    },
    {
      day: 14,
      emails: [
        {
          type: "arrears",
          subject: `${vehicle_reg} - Immediate Payment Required to Avoid Cancellation`,
          template: em8_arrears,
        },
      ],
      sms: [
        {
          type: "arrears",
          message: `Reminder: ${vehicle_reg} payment of £${total_due} is still unpaid. Pay today to prevent cancellation and credit issues: ${payment_link} or call ${phone_number}`,
        },
      ],
    },
    {
      day: 16,
      emails: [
        {
          type: "arrears",
          subject: `${vehicle_reg} - Insurance Will Be Cancelled on ${cancellation_date} Unless Paid`,
          template: em9_arrears,
        },
      ],
      sms: [
        {
          type: "arrears",
          message: `Urgent: ${vehicle_reg} payment of £${total_due} still unpaid. Policy will cancel on ${cancellation_date} unless paid: ${payment_link} or call ${phone_number}`,
        },
      ],
    },
    {
      day: 18,
      emails: [
        {
          type: "arrears",
          subject: `${vehicle_reg} - Immediate Payment Required to Avoid Cancellation`,
          template: em8_arrears,
        },
      ],
      sms: [
        {
          type: "arrears",
          message: `Reminder: ${vehicle_reg} payment of £${total_due} is still unpaid. Pay today to prevent cancellation and credit issues: ${payment_link} or call ${phone_number}`,
        },
      ],
    },
    {
      day: 20,
      emails: [
        {
          type: "arrears",
          subject: `${vehicle_reg} - Insurance Will Be Cancelled on ${cancellation_date} Unless Paid`,
          template: em9_arrears,
        },
      ],
      sms: [
        {
          type: "arrears",
          message: `Urgent: ${vehicle_reg} payment of £${total_due} still unpaid. Policy will cancel on ${cancellation_date} unless paid: ${payment_link} or call ${phone_number}`,
        },
      ],
    },
    {
      day: 21,
      emails: [
        {
          type: "arrears",
          subject: `${vehicle_reg} - Notice of Cancellation - Policy Set to Cancel Today`,
          template: em11_arrears,
        },
      ],
      sms: [
        {
          type: "arrears",
          message: `NOTICE: Your policy for ${vehicle_reg} is set to cancel. Call ${phone_number} urgently if you still need cover. Balance £${total_due} remains due.`,
        },
      ],
    },

  ];

  const dayContent = contentData.find((c) => c.day === day);

  return {
    email: dayContent?.emails.find((e) => e.type === type),
    sms: dayContent?.sms.find((s) => s.type === type),
  };
};

export default chaseTimeLineData;
